import { global } from "../../constants";

export const data = {
  banner: {
    base: "服务",
    background: global.banner + "maritime-law.webp",
    title: "海事法",
    crumb: "海事法",
  },
  icon: "fa-solid fa-gavel",
  shortDescription:
    "在海事操作、合同和合规方面提供专业法律建议。",

  title: "海事法",
  features: {
    title: "海事法",
    deliverables: "交付物",
    reqDocuments: "所需文件",
    subtitle: "在海事操作、合同和合规方面提供专业法律建议。",
    description: `海事法的综合建议：合同的起草和谈判、登记程序、租船、购买/销售的尽职调查以及海事劳动建议。`,
    viewDetail: "查看详情",
    feats: [
      {
        key: "contracts",
        title: "量身定制的海事合同起草和谈判",
        summary:
          "合同（租船、代理、修理、港口服务）具有责任条款、保险和仲裁。",
        details:
          "定制起草，审查关键条款（装船时间、滞期费、P&I、不可抗力），谈判和提出替代方案以降低风险。",
        deliverables: [
          "法律草案（Word/PDF）",
          "关键条款的执行摘要",
          "风险清单",
        ],
        requiredDocs: [
          "派对数据",
          "先前的商业条款",
          "操作的技术文档",
        ],
        icon: "fa-solid fa-file-contract",
        image: global.services + "editorial.jpeg",
      },
      {
        key: "registry",
        title: "在委内瑞拉海军登记处的管理和程序",
        summary:
          "在海军登记处进行注册、转让、抵押权注释和文件管理。",
        details:
          "准备文件，提交给主管部门，跟进并获取登记证书；如有必要，与专家和技术人员协调。",
        deliverables: [
          "文件准备完毕",
          "提交收据",
          "最终证书交付",
        ],
        requiredDocs: [
          "产权证",
          "公证权力",
          "船舶技术证书",
        ],
        icon: "fa-solid fa-passport",
        image: global.services + "consulting.webp",
      },
      {
        key: "charter",
        title: "关于租船（时间租船和航程租船）的建议",
        summary:
          "租船合同的谈判和起草、装船时间计算以及滞期费索赔的处理。",
        details:
          "关于选择租船类型的建议、起草操作条款、装船时间/滞期费计算及示例，以及通知程序。",
        deliverables: [
          "租船合同/条款",
          "装船时间计算示例",
          "索赔管理程序",
        ],
        requiredDocs: [
          "计划行程",
          "船舶文件",
          "商业条件",
        ],
        icon: "fa-solid fa-anchor",
        image: global.services + "management.jpg",
      },
      {
        key: "purchase",
        title: "船舶的购买和销售：尽职调查和合同起草",
        summary:
          "法律和技术尽职调查、SPA起草、托管管理和登记转让。",
        details:
          "对抵押权、技术证书、维护历史的验证；协调检查和合同中的赔偿及托管条款。",
        deliverables: [
          "尽职调查报告",
          "购买草案",
          "转让计划",
        ],
        requiredDocs: [
          "登记证书",
          "维护历史",
          "技术证书",
        ],
        icon: "fa-solid fa-ship",
        image: global.services + "purchase.jpeg",
      },
      {
        key: "labor",
        title: "关于海事劳动法和冲突解决的建议",
        summary:
          "船员合同、劳动索赔、遵守公约和争议代表。",
        details:
          "起草海事劳动合同、索赔协议、在行政和司法程序中的代表、对船上劳动风险的预防性管理。",
        deliverables: [
          "劳动合同模板",
          "索赔程序",
          "谈判支持",
        ],
        requiredDocs: [
          "现有合同",
          "能力证书",
          "事件历史",
        ],
        icon: "fa-solid fa-people-roof",
        image: global.services + "labor-law.jpg",
      },
    ],
  },
  ctaText: "请求法律建议",
  ctaLink: "/contact?service=maritime-law",
};
